// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /** Versión de la app (alinear con package.json en releases). */
  appVersion: '0.0.1',
  /**
   * Plantilla URL pública del sitio del tenant para “Ver sitio”. Usá `{slug}` como placeholder.
   * Ej.: `https://{slug}.tu-dominio.com` o vacío para deshabilitar el enlace hasta configurar.
   */
  publicTenantSiteUrlTemplate: 'https://{slug}.cooperativa.net.ar' as string,
  /** Origen del login (Auth no admite `*.`). El sitio del slug redirige acá para ingresar. */
  publicAuthOrigin: 'https://cooperativa.net.ar' as string,
  /**
   * URL del logo del tenant en la barra del workspace. Usá `{slug}`.
   * Vacío → se usa `assets/cooperativa.svg` hasta que exista logo por cooperativa (p. ej. Storage).
   */
  tenantLogoUrlTemplate: '' as string,
  firebase: {
    // Reemplazá con los valores de Firebase Console → Proyecto cooperativadev → ⚙️ Configuración → Tus apps → Web.
    // Si no tenés app web, agregala y copiá el objeto firebaseConfig.
    apiKey: 'AIzaSyC5dPtDzTRZyCfgwfpzUP8AroXJV-k9hGc',
    authDomain: 'cooperativadev-73aa9.firebaseapp.com',
    projectId: 'cooperativadev-73aa9',
    storageBucket: 'cooperativadev-73aa9.firebasestorage.app',
    messagingSenderId: '898070539983',
    appId: '1:898070539983:web:54cbd220c15a9b2d8d91ba',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
